
import React, { useEffect, ChangeEvent, useState, useRef } from 'react'
import TextInput from '../../../components/TextInput';
import { bindActionCreators } from 'redux';
import { getCustomer, saveCustomer, getCountryList } from '../../../store/actions/management';
import { GetCustomer, UpdateCustomerField } from '../../../store/actions/actionTypes';
import { connect } from 'react-redux';
import { ICustomer, UserColumns, ICountryList } from '../../../shared/models/adminModels'
import { IFormState } from '../../../shared/models/validations'
import { checkFieldValidation, checkProperties } from '../../../services/utilService'
import update from 'react-addons-update';
import { useHistory } from 'react-router';
import { selectCustomer, updateSearchedName, toggleShowCustomerModal } from '../../../store/actions/returnNote';
import { setModalError } from '../../../store/actions/common';

interface IProps {
  isEdit?: boolean;
  customerId?: string;
  customer: ICustomer;
  getCustomer: Function;
  setCustomer: Function;
  saveCustomer: Function;
  updateCustomerField: Function;
  isOpenFromModal?: boolean;
  selectCustomer: Function;
  updateSearchedName: Function;
  isLoading: boolean;
  modalError: string;
  toggleShowCustomerModal: Function;
  setModalError: Function;
  getCountryList: Function;
  countryList: ICountryList[];
}


const CustomerForm = (props: IProps) => {
  const [customerForm, setCustomerForm] = useState<IFormState>({
    valid: false,
    errors: {},
    validations: {
      [UserColumns.CustomerName]: {
        label: 'Customer Name',
        required: true,
      },
      [UserColumns.ContactFirstName]: {
        label: 'Contact FirstName',
        required: true,
      },
      [UserColumns.ContactSurName]: {
        label: 'Contact LastName',
        required: true,
      },
      [UserColumns.Email]: {
        label: 'Email',
        required: true,
        email: true
      },
      [UserColumns.Telephone]: {
        label: 'Telephone',
        phone: true
      },
      [UserColumns.CountryId]: {
        label: 'Country',
        required: true
      },
      [UserColumns.County]: {
        label: 'County',
        required: true
      }
    }
  });
  const history = useHistory();

  //ref
  const modalDiv = useRef(null);

  const {
    isEdit = false,
    customerId,
    customer,
    isOpenFromModal = false,
    selectCustomer,
    updateSearchedName,
    isLoading,
    modalError,
    setModalError,
    toggleShowCustomerModal
  } = props;
  useEffect(() => {
    props.getCountryList();
    if (isEdit) {
      props.getCustomer(customerId);
    } else {
      props.setCustomer({});
      props.setModalError(null);
      props.updateCustomerField('active', true);
      props.updateCustomerField('countryId', '71ad6b35-f74a-4d66-944b-4d928d88e2c9'); // Default is UK
    }
  }, [isEdit]);

  const handleChange = (e: ChangeEvent<HTMLInputElement> | any) => {
    const { type, name, value, checked } = e.target;
    if (type === 'checkbox') {
      props.updateCustomerField(name, checked);
      return false;
    }
    props.updateCustomerField(name, value);
    if (Object.keys(customerForm.validations).includes(name)) {
      const error = checkFieldValidation(customerForm.validations[name], value);
      setCustomerForm(update(customerForm, {
        errors: {
          [name]: { $set: error }
        }
      }))
    }
  }

  const checkFormValidation = () => {
    let errors: any = {};
    type ICustomerField = keyof ICustomer;
    Object.keys(customerForm.validations).forEach((field: any) => {
      const fieldName: ICustomerField = field
      errors[fieldName] = checkFieldValidation(customerForm.validations[fieldName], customer[fieldName]);
    });
    return errors;
  }

  const saveCustomer = async () => {
    const errors = await checkFormValidation();
    const form = {
      ...customerForm,
      errors
    }
    setCustomerForm(form);
    const noError = checkProperties(form.errors);
    if (noError) {
      const res = await props.saveCustomer(customer, isEdit, isOpenFromModal);
      if (res && res.isSuccess && !isOpenFromModal) {
        history.goBack();
      } else if (res && res.isSuccess && res.data && res.data.id && isOpenFromModal) {
        // update customer on returnNote
        toggleShowCustomerModal(false);
        updateSearchedName(res.data.customerName);
        selectCustomer(res.data);
      } else if (!res.isSuccess && isOpenFromModal) {
        // @ts-ignore
        modalDiv.current.scrollIntoView();
      }
    }
  }
  const { errors } = customerForm;
  return (
    <div className="page-content ">
      <div className="row" ref={modalDiv}>
        {isOpenFromModal && <div className="text-danger">{modalError}</div>}
        <div className={isOpenFromModal ? "profile-card border-btm-blue mb-5 w-100" : "profile-card box-shaddow border-btm-blue mb-5 w-100"}>
          {!!isEdit &&
            <div className="profile-top">
              <h3 className="mt-5"> Company Name</h3>
              <span className="cust-num mb-3">#{customer.customerId || '-'}</span>
            </div>
          }
          <div className="profile-status">
            <div className="pro-status-wrap">
              <div className="status-text" style={{ paddingLeft: isOpenFromModal ? 15 : 0 }}>Active</div>
              <div className="custom-control custom-switch">
                <TextInput type="checkbox" className="custom-control-input" id="customSwitch1" name="active"
                  checked={isEdit ? customer.active : true}
                  disabled={!isEdit}
                  onChange={handleChange}
                  data-size="lg" />
                <label className="custom-control-label" htmlFor="customSwitch1"></label>
              </div>
            </div>
          </div>
          <div className="profile-content">
            <form action="" className="witt-check">
              <div className="form-group">
                <label>Customer Name</label>
                <TextInput placeholder="Customer Name" name="customerName"
                  value={customer.customerName}
                  error={errors.customerName}
                  onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Contact First Name</label>
                <TextInput placeholder="Contact First Name" name="contactFirstName"
                  value={customer.contactFirstName}
                  error={errors.contactFirstName}
                  onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Contact Last Name</label>
                <TextInput placeholder="Contact Last Name" name="contactSurname"
                  value={customer.contactSurname}
                  error={errors.contactSurname}
                  onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <TextInput placeholder="Email Address" name="email"
                  value={customer.email}
                  error={errors.email}
                  onChange={handleChange} />
              </div>
              <div className="form-group">
                <label> Address</label>
                <TextInput placeholder="Address Line 1" name="address1" className="form-control mb-3" value={customer.address1} onChange={handleChange} />
                <TextInput placeholder="Address Line 2" name="address2" className="form-control mb-3" value={customer.address2} onChange={handleChange} />
                <TextInput placeholder="Town" name="town" className="form-control mb-3" value={customer.town} onChange={handleChange} />
                <TextInput placeholder="City" name="city" className="form-control mb-3" value={customer.city} onChange={handleChange} />
                <select
                  className="form-control"
                  name="countryId"
                  onChange={handleChange}
                  value={customer.countryId}
                >
                  {/* <option value=''>Select</option> */}
                  {props.countryList.map((item: any) => (
                    <option key={item.id} value={item.id}>{item.countryName}</option>
                  ))}
                </select>
                <div className="text-danger">
                  {errors.countryId}
                </div>
                <div className='mb-3'></div>
                <TextInput placeholder="County" name="county" className="form-control" value={customer.county} onChange={handleChange} error={errors.county} />
                <div className='mb-3'></div>
                <TextInput placeholder="Postal Code" name="postcode" className="form-control" value={customer.postcode} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <TextInput placeholder="Telephone" name="telephone"
                  value={customer.telephone}
                  error={errors.telephone}
                  onChange={handleChange} />
              </div>
              <div className="form-group">
                <button disabled={isLoading} type="button" onClick={() => saveCustomer()} className="btn btn-primary w-100 mb-2">Save</button>
                {!isOpenFromModal && <button className="btn btn-outline w-100" onClick={() => history.push('/manage-customers')}>Cancel</button>}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  return ({
    customer: state.managementReducer.customer,
    isLoading: state.common.isLoading,
    modalError: state.common.modalError,
    countryList: state.managementReducer.countryList,
  })
}

const mapDispatchToProps = (dispatch: any) => ({
  getCustomer: bindActionCreators(getCustomer, dispatch),
  saveCustomer: bindActionCreators(saveCustomer, dispatch),
  setCustomer: (customer: ICustomer) => dispatch({ type: GetCustomer, payload: customer }),
  updateCustomerField: (field: string, value: string | number) => dispatch({ type: UpdateCustomerField, payload: { field, value } }),
  selectCustomer: (customer: ICustomer) => dispatch(selectCustomer(customer)),
  updateSearchedName: (value: string) => dispatch(updateSearchedName(value)),
  toggleShowCustomerModal: (value: boolean) => dispatch(toggleShowCustomerModal(value)),
  setModalError: (value: string) => dispatch(setModalError(value)),
  getCountryList: (value: string) => dispatch(getCountryList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerForm)

